/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'previous': {
    width: 9.968,
    height: 16.969,
    viewBox: '0 0 9.968 16.969',
    data: '<path pid="0" d="M8.535 16.982L-.001 8.491 8.535 0 9.97 1.427l-7.1 7.064 7.1 7.064z" fill-rule="evenodd"/>'
  }
})
